export enum BusinessModel {
    PayLater = 0,
    PrePayment = 1
}
